import { jsx as _jsx } from "react/jsx-runtime";
import { buildElementStyling } from '../utils';
const RichTextH2 = ({ children, value }) => {
    const { className, style } = buildElementStyling({ baseClass: 'richTextH2', value });
    return (_jsx("h2", { className: className, style: style, children: children }));
};
RichTextH2.displayName = 'RichTextH2';
export default RichTextH2;
//# sourceMappingURL=Heading2.js.map